<template>
  <b-modal id="expanded-chart" size="xl" hide-footer>
    <weights-chart
      :portfolio="expandedChart.data"
      isExpanded
      v-if="expandedChart.type === 'weights'"
    />
    <covariance-matrix
      v-else
      :data="expandedChart.data.data"
      :displayTickers="expandedChart.data.displayTickers"
      isExpanded
    />
  </b-modal>
</template>

<script>
import CovarianceMatrix from "../charts/CovarianceMatrix.vue";
import WeightsChart from "../charts/WeightsChart.vue";
import { mapGetters } from "vuex";
export default {
  name: "expanded-chart-modal",
  components: {
    WeightsChart,
    CovarianceMatrix,
  },
  computed: {
    ...mapGetters("portfolioManagerStore", ["expandedChart"]),
  },
};
</script>

<style>
</style>